module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_2.ba5bd9db.png";